<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0.5 2C0.5 1.17 1.17 0.5 2 0.5C2.83 0.5 3.5 1.17 3.5 2C3.5 2.83 2.83 3.5 2 3.5C1.17 3.5 0.5 2.83 0.5 2ZM0.5 8C0.5 7.17 1.17 6.5 2 6.5C2.83 6.5 3.5 7.17 3.5 8C3.5 8.83 2.83 9.5 2 9.5C1.17 9.5 0.5 8.83 0.5 8ZM2 12.5C1.17 12.5 0.5 13.18 0.5 14C0.5 14.82 1.18 15.5 2 15.5C2.82 15.5 3.5 14.82 3.5 14C3.5 13.18 2.83 12.5 2 12.5ZM19 15H5V13H19V15ZM5 9H19V7H5V9ZM5 3V1H19V3H5Z"
  />
</template>
